import { app } from '../../../../app';

app.component('socialProfilesInfo', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    templateUrl: require('./social.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/profiles/social/social.component.js